module.exports = __webpack_public_path__ + "img/drops-bg1.8e605ae8.webp";